import { Component, inject, Inject } from '@angular/core';
import { OwnershipModel } from '../../models/ownership-model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { LookupDataService } from '../../services/lookup-data.service';
import { LookupItem, LookupValueMapper } from '../../models/lookup-item';
import { AssessmentService } from '../../services/assessment.service';
import { FormGroup, NonNullableFormBuilder, Validators } from '@angular/forms';
import { InvestmentYear } from '../../models/investment-year';

@Component({
  selector: 'app-ownership-dialog',
  templateUrl: './ownership-dialog.component.html',
  styleUrl: './ownership-dialog.component.scss'
})
export class OwnershipDialogComponent {

  assessmentService = inject(AssessmentService);
  formBuilder = inject(NonNullableFormBuilder);

  submitForm = false;
  model: OwnershipModel;
  countries!: LookupItem[];
  industries!: LookupItem[];
  ownershipInterests!: LookupItem[];
  assetAmounts!: LookupItem[];

  constructor(
    public dialogRef: MatDialogRef<OwnershipDialogComponent>, private lookupDataService: LookupDataService,
    @Inject(MAT_DIALOG_DATA) public data: { model: OwnershipModel, countries: LookupItem[], industries: LookupItem[], ownershipInterests: LookupItem[], assetAmounts: LookupItem[] }
  ) {
    this.model = data.model || new OwnershipModel();
    this.countries = data.countries || [];
    this.industries = data.industries || [];
    this.ownershipInterests = data.ownershipInterests || [];
    this.assetAmounts = data.assetAmounts || [];
  }

    ngOnInit(): void {    
      this.handleFormModelBinding();
    }

    handleFormModelBinding() {
      
      // Bind form to model data
      this.ownershipForm?.patchValue({
        ...this.model,
        country: LookupValueMapper.toLookupItem(this.model.country)
      });   
      
      // Subscribe to form changes to update model
      this.ownershipForm?.valueChanges.subscribe(value => {
        this.model = {
          ...this.model!,
          ...value,
          country: LookupValueMapper.toLookupValue(value.country),
          years: value.years as InvestmentYear[]
        }
      });
    }

  ownershipForm = this.formBuilder.group({
        name: ['', [Validators.required]],
        country: [null as LookupItem | null],
        industry: [null as LookupItem | null],
        ownershipInterest: [null as LookupItem | null],
        position: [''],
        dateStart: ['', [Validators.required]],
        years: this.formBuilder.array([
          this.createInvestmentYearGroup(),
          this.createInvestmentYearGroup(),
          this.createInvestmentYearGroup(),
          this.createInvestmentYearGroup()
        ])         

      });

  // ownership interest is a string
  // but it must be a number format, beteween 0 and 100
  createInvestmentYearGroup(){
    return this.formBuilder.group({
      turnover: [null as LookupItem | null],
      ownershipInterest: ['', [Validators.pattern("^(100(\\.0{1,2})?|\\d{1,2}(\\.\\d{1,2})?)$")]],
      netAssets: [null as LookupItem | null],
      yearEnd: ['']
    });
  }


  close(): void {
    this.submitForm = true;
    if(this.ownershipForm.valid){
      this.dialogRef.close(this.model);
    }
    // If the form is invalid, stay open and show validation errors
    this.ownershipForm.markAllAsTouched();
    this.submitForm = false;
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
